import { formatNumber } from "../../utils/helpers";

const YTAccountStat: React.FC<{ videosCount: number, subscribersCount: number, viewsCount: number, engagementScore: number | null, engagementRate: number | null, engagementRateDetails: { name: string, color: string } | null }> = ({ videosCount, subscribersCount, viewsCount, engagementScore, engagementRate, engagementRateDetails}) => {
    return (
        <div className="card rounded-4 shadow-none border-0 mb-0">
            <div className="card-body d-flex flex-wrap justify-content-evenly flex-row rounded-4 px-0 py-2">
                <div className="d-flex w-100 py-2 text-center">
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1">{formatNumber(videosCount ?? 0)}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Videos</span>
                    </div>
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1">{formatNumber(subscribersCount ?? 0)}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Subscribers</span>
                    </div>
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1">{formatNumber(viewsCount ?? 0)}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Views</span>
                    </div>
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1 d-flex justify-content-center align-item">{engagementScore}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Engagement Score</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default YTAccountStat;